// Tools - Users
import Axios from 'axios';
import moment from 'moment';

const ADMIN_LVL_MASTER = 0;
const ADMIN_LVL_CHARTERS = 1;
const ADMIN_LVL_LEAGUES = 2;
const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;
const ADMIN_LVL_ADMINLIMIT = 20;
const ADMIN_LVL_NOACCESS = 99;

var getAccessLevel = function(profile, callback) {

	//console.log('Users getAccessLevel');
	//console.log(profile);

 	Axios.get('/api/users/byAuthUserId/' + profile.user_id).then(function (response) {
		callback(response.data.adminLevel);
  });
};

var getValidateAccessLevel = function(profile, charterId, leagueId, seasonId, callback) {

	console.log('Users: getValidateAccessLevel');
	console.log(profile);
	//console.log(seasonId);

	var retAccessLevel = ADMIN_LVL_NOACCESS;
	var adminLevel = ADMIN_LVL_NOACCESS;
	var adminInfoTxt = 'Aucun accès';

	var charters = [];
	var leagues = [];
	var seasons = [];

    Axios.get('/api/users/byAuthUserId/' + profile.user_id).then(function (response) {
      	
		adminLevel = response.data.adminLevel;
		charters = response.data.charters;
		leagues = response.data.leagues;
		seasons = response.data.seasons;

		switch (adminLevel) {

			// Master
			case ADMIN_LVL_MASTER:
				retAccessLevel = adminLevel;
				adminInfoTxt = 'MASTER'
				break;

			// Charters
			case ADMIN_LVL_CHARTERS:
				// Validate leagues
				charters.forEach(function (charter) {
					if (charter.id === charterId) {
						retAccessLevel = adminLevel;	// Access rights granted
						adminInfoTxt = 'CHARTER';
					}
				});
				break;

			// Leagues
			case ADMIN_LVL_LEAGUES:
				// Validate leagues
				leagues.forEach(function (league) {
					if (league.id === leagueId) {
						retAccessLevel = adminLevel;	// Access rights granted
						adminInfoTxt = 'LIGUE';
					}
				});
				break;

			// Seasons
			case ADMIN_LVL_SEASONS:
				// Validate seasons
				seasons.forEach(function (season) {
					if (season.id === seasonId) {
						retAccessLevel = adminLevel;	// Access rights granted
						adminInfoTxt = 'SAISON';
					}
				});
				break;

			// Scoresheets
			case ADMIN_LVL_SCORESHEETS:
				// Validate seasons
				seasons.forEach(function (season) {
					if (season.id === seasonId) {
						retAccessLevel = adminLevel;	// Access rights granted
						adminInfoTxt = 'POINTAGES';
					}
				});
				break;

			// Other access
			default:
				retAccessLevel = adminLevel;
				adminInfoTxt = 'SPECIAL ADMIN'
				break;
		}

		// console.log('Votre niveau Admin est: ' + retAccessLevel + ' (' + adminInfoTxt + ')');
      	callback(retAccessLevel);
    });
};

var getAccessLevelText = function(accessLevel) {

	if ((accessLevel < ADMIN_LVL_MASTER) || (accessLevel > ADMIN_LVL_SCORESHEETS)) {
		return ('AUCUN ACCES');
	} else {
		var accessText = '';
		switch(accessLevel) {
			case 0:
				accessText = 'MASTER';
				break;
			case 1:
				accessText = 'CHARTER';
				break;
			case 2:
				accessText = 'LIGUE';
				break;
			case 3:
				accessText = 'SAISON';
				break;
			case 10:
				accessText = 'POINTAGES';
				break;
			default:
				break;
		}
		return accessText;
	}
};

var AdminGlobalAccessOK = function(adminGlobalAccessLevel) {

	if(adminGlobalAccessLevel <= ADMIN_LVL_ADMINLIMIT) {
		return true;
	}
	return false;
};

var getUserInfo = function(auth_user_id, callback) {

	var result = {};
    Axios.get('/api/users/byAuthUserId/' + auth_user_id).then(function (responseUser) {

      result._id = responseUser.data._id;
      result.name = responseUser.data.name;

			result.streetaddress = responseUser.data.streetaddress;	// street-address
			result.addresslevel1 = responseUser.data.addresslevel1;	// state/prov
			result.addresslevel2 = responseUser.data.addresslevel2;	// city
			result.postalcode = responseUser.data.postalcode;		// postalcode
			result.country = responseUser.data.country;
			result.tel = responseUser.data.tel;
			result.email = responseUser.data.email;

      result.playerId = responseUser.data.playerId;
     	result.playerName = '';
      result.memberActive = responseUser.data.memberActive;
      result.memberDateActivation = responseUser.data.memberDateActivation;
      result.memberDateExpiration = responseUser.data.memberDateExpiration;

      result.lastConnectionDate = responseUser.data.lastConnectionDate;
      result.inscriptionDate = responseUser.data.inscriptionDate;
      result.profilePicture = responseUser.data.profilePicture;
      result.adminLevel = responseUser.data.adminLevel;
      result.organisationsId = responseUser.data.organisationsId;
      
      result.userUpdatedProfile = responseUser.data.userUpdatedProfile;

   		var thisDate = moment().startOf('day').format("YYYY-MM-DD");
			var expDate = moment(result.memberDateExpiration).startOf('day');
			result.expDelay = expDate.diff(thisDate, 'days') + 1;

    	Axios.get('/api/players/playerid/' + result.playerId).then(function (responsePlayer) {

     		if (responsePlayer.data.length !== 0) {
					result.playerName = responsePlayer.data.firstname + ' ' + responsePlayer.data.lastname;
     		}

  	   	callback(result);
	    });
    });
};

var setNewConnection = function(userData, callback) {

	//console.log('Set new Connection');
	//console.log(userData)
	//alert("MESSAGE IMPORTANT\nUne maintenance est actuellement en cours au niveau de la connection.\nPendant ce temps, vous n'avez pas accès au mode admin ni au tableau de bord.  La maintenance est prévue se terminer en fin de journée.  Merci.  Pat Poulin");

	// Set new connection (create or update existing user)
	Axios.post('/api/users/userNewConnection/' + userData.user_id, {
		userData: userData,
	})
	.then(function(response) {

	   	Axios.get('/api/users/byAuthUserId/' + userData.user_id).then(function (response) {

	   		var userId = response.data._id;

			// set new connection event in table
			Axios.post('/api/connections/', {
				userId: userId,
				userData: userData
			})
			.then(function(response) {
				// console.log('new connection inserted');
				callback();
			})
			.catch(function(error) {
				console.log(error);
				callback();
			});
	    });
	})
	.catch(function(error) {
		console.log(error);
		callback();
	});
};

var IsBetaTester = function(userId) {

	// support different types of testers
	const cstBetaTesterUserIds = [
		'facebook|10154270424783768',	// Patrick Poulin
		'facebook|10154730500671746',	// Tremblay, Eve
    	'facebook|10155929984112018', // Richard Jobin
		// 'facebook|60000014300722',    // Eric Martin
    	'google-oauth2|109957358636174977228', // Mat Bergeron
	];

	var isBetaTester = false;
	if(userId !== undefined) {
		for (var idx = 0; idx < cstBetaTesterUserIds.length; idx++) {
			if (userId.toString() === cstBetaTesterUserIds[idx]) {
				isBetaTester = true;
			}
		}
	}

	return isBetaTester;
};

var getCharterAdmin = function(profile, callback) {
  Axios.get('/api/users/byAuthUserId/' + profile.user_id).then(function (response) {
  	var charterAdmin = '';
  	if (response.data.charterAdmin !== undefined) {
  		charterAdmin = response.data.charterAdmin;
  	};
  	callback(charterAdmin)
	});
}

export default {
	getAccessLevel: getAccessLevel,
	getValidateAccessLevel: getValidateAccessLevel,
	getAccessLevelText: getAccessLevelText,
	AdminGlobalAccessOK: AdminGlobalAccessOK,
	getUserInfo: getUserInfo,
	setNewConnection: setNewConnection,
	IsBetaTester: IsBetaTester,
	getCharterAdmin: getCharterAdmin
};
